import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { HotelDiscover } from 'app/typings/hotels/Hotel/HotelDiscover';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useGetHotelDiscover({
  hotelId: id,
  forceDisable,
}: {
  hotelId?: string | number;
  forceDisable?: boolean;
}) {
  const hotelId = typeof id === 'string' ? id : id?.toString();

  const response = useQuery({
    queryKey: [CORE_QUERY_KEYS.hotel, { id: hotelId }],
    queryFn: hotelId
      ? () =>
          apiRequest({
            path: ENDPOINTS.getHotelDiscover,
            params: { id: hotelId },
          }) as Promise<HotelDiscover>
      : () => Promise.resolve(undefined),
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!hotelId && !forceDisable,
  });

  return response;
}
